export default __webpack_public_path__ + "static/media/blog-05.fc755611.jpg";